module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_diamond__v_shadow.e58f4643.png";